/* 
Add Script Tag inside theme.liquid Head Tag: 
<!-- Consent Mode Script -->
<script defer src="{{ 'consent_mode.js' | asset_url }}"></script> 
*/
window.dataLayer = window.dataLayer || [];
function gtag() {
  dataLayer.push(arguments);
}

// Initialize Default Consent Mode
if (localStorage.getItem("consentMode") === null) {
  gtag("consent", "default", {
    ad_storage: "denied",
    analytics_storage: "denied",
    personalization_storage: "denied",
    functionality_storage: "denied",
    security_storage: "denied",
  });
} else {
  gtag("consent", "default", JSON.parse(localStorage.getItem("consentMode")));
}

function setConsent(consent) {
  const consentMode = {
    functionality_storage: consent.necessary ? "granted" : "denied",
    security_storage: consent.necessary ? "granted" : "denied",
    ad_storage: consent.marketing ? "granted" : "denied",
    analytics_storage: consent.analytics ? "granted" : "denied",
    personalization_storage: consent.preferences ? "granted" : "denied",
  };
  gtag("consent", "update", consentMode);
  localStorage.setItem("consentMode", JSON.stringify(consentMode));
}

function waitForElement(selector) {
  return new Promise((resolve) => {
    const intervalId = setInterval(() => {
      const element = document.getElementById(selector);
      if (element) {
        clearInterval(intervalId);
        resolve(element);
      }
    }, 100);
  });
}

async function retrieveShopifyBanner() {
  const shopifyBanner = await waitForElement("shopify-pc__banner");
  if (shopifyBanner) {
    // Shopify Banner Accept Button
    document
      .getElementById("shopify-pc__banner__btn-accept")
      .addEventListener("click", function () {
        setConsent({
          necessary: true,
          analytics: true,
          preferences: true,
          marketing: true,
        });
      });

    // Shopify Manage Preferences Button
    document
      .getElementById("shopify-pc__banner__btn-manage-prefs")
      .addEventListener("click", function () {
        // Shopify Cookie Settings Accept Button
        document
          .getElementById("shopify-pc__prefs__header-accept")
          .addEventListener("click", function () {
            setConsent({
              necessary: true,
              analytics: true,
              preferences: true,
              marketing: true,
            });
          });

        // Shopify Cookie Settings Decline Button
        document
          .getElementById("shopify-pc__prefs__header-decline")
          .addEventListener("click", function () {
            setConsent({
              necessary: false,
              analytics: false,
              preferences: false,
              marketing: false,
            });
          });

        // Shopify Preferences Selection Accept Button
        document
          .getElementById("shopify-pc__prefs__header-save")
          .addEventListener("click", function () {
            setConsent({
              necessary: true,
              analytics: document.getElementById(
                "shopify-pc__prefs__analytics-input"
              ).checked,
              preferences: document.getElementById(
                "shopify-pc__prefs__preferences-input"
              ).checked,
              marketing: document.getElementById(
                "shopify-pc__prefs__marketing-input"
              ).checked,
            });
          });
      });

    // Shopify Banner Decline Button
    document
      .getElementById("shopify-pc__banner__btn-decline")
      .addEventListener("click", function () {
        setConsent({
          necessary: false,
          analytics: false,
          preferences: false,
          marketing: false,
        });
      });
  }
}

retrieveShopifyBanner();
